export default __webpack_public_path__ + "static/media/me.f7262032.JPG";